import { styled } from "@mui/material/styles";
import { MaterialDesignContent } from "notistack";
import colors from "./colors";

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent": {
    padding: "0 10px 0 0",
    backgroundColor: "white",
    overflow: "hidden",
    color: "black"
  },
  "&.notistack-MuiContent:has(.twolines)": {
    "& svg": {
      alignSelf: "stretch",
      padding: "18px 4px"
    }
  },
  "& #notistack-snackbar": {
    padding: "0",
    b: { paddingRight: "3px" }
  },
  "& #notistack-snackbar .twolines": {
    display: "flex",
    flexDirection: "column",
    padding: "0 8px 0 0"
  },
  "& svg": {
    padding: "10px 4px"
  },
  "&.notistack-MuiContent-success": {
    b: { color: colors.snackbar.success["500"] },
    "& svg": {
      backgroundColor: colors.snackbar.success["200"],
      color: colors.snackbar.success["500"]
    }
  },
  "&.notistack-MuiContent-error": {
    b: { color: colors.snackbar.error["500"] },
    "& svg": {
      backgroundColor: colors.snackbar.error["200"],
      color: colors.snackbar.error["500"]
    }
  },
  "&.notistack-MuiContent-warning": {
    b: { color: colors.yellow["800"] },
    "& svg": {
      backgroundColor: colors.yellow["100"],
      color: colors.yellow["800"]
    }
  },
  "&.notistack-MuiContent-info": {
    b: { color: colors.snackbar.info["500"] },
    "& svg": {
      backgroundColor: colors.snackbar.info["200"],
      color: colors.snackbar.info["500"]
    }
  }
}));

export const notistackStyled = {
  StyledMaterialDesignContent
};
